module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/USB-29841c94f406b66ed7ddd4f51f03bac1.svg";